module.exports = __webpack_public_path__ + "img/changpinghongpa.5834c3df.png";